const React = require("react")
const _get = require('lodash/get')
const App = require("./src/components/app.js").default
const { IntlProvider } = require("react-intl")
const { WL } = require("./src/constants/whiteLabel")
const { ReduxWrapper } = require("./src/ReduxWrapper")

const LANGUAGES = {
  zh: 'zh',
};
const KEY_PAGE_404 = '/404.html';

const PAGES_WITH_PREVENT_SCROLL = [
  '/asic',
  '/asic/l3',
  '/asic/s9',
  '/asic/s10',
  '/asic/s17',
  '/asic/t9',
  '/asic/t17',
  '/asic/t19',
  '/asic/s19',
  '/changelog',
];

const getPreventScrollPages = (pathes = [], langs = []) => {
  return pathes.reduce((acc, path) => {
    const pagesWithLangSufix = [`${path}/`, ...langs.map(lang => `/${lang}${path}/`)];
    return [...acc, ...pagesWithLangSufix];
  }, []);
}

exports.wrapPageElement = ({ element }) => {
  const pagePath = _get(element, 'props.pageResources.page.path', '')
  const isPage404 = pagePath === KEY_PAGE_404;
  const pathname = _get(element, 'props.location.pathname', '');
  const contextLang = _get(element, 'props.pageContext.lang', '');
  const contextLangKb = _get(element, 'props.pageContext.currentLang', '');
  let lang = contextLang || contextLangKb || 'en';

  if(isPage404) {
    const {ru, zh} = LANGUAGES;

    const isRuLocale = pathname.match(`/${ru}/`)?.index === 0;
    const isZhLocale = pathname.match(`/${zh}/`)?.index === 0;

    lang = isRuLocale ? ru : isZhLocale ? zh : 'en';
  }

  const messages = WL.getMessages();
  const currentMessages = _get(messages, lang, messages.en);

  return (
    <ReduxWrapper>
      <IntlProvider locale={lang} messages={currentMessages}>
        <App>
          {element}
        </App>
      </IntlProvider>
    </ReduxWrapper>
  );
};

exports.shouldUpdateScroll = ({
  routerProps,
  prevRouterProps,
}) => {
  const location = _get(routerProps, 'location');
  const prevLocation = _get(prevRouterProps, 'location');

  const preventScrollPathes = getPreventScrollPages(PAGES_WITH_PREVENT_SCROLL, Object.values(LANGUAGES));

  // check prevent scroll pathes to prevent scroll between them
  if (
    preventScrollPathes.includes(_get(location, 'pathname')) &&
    preventScrollPathes.includes(_get(prevLocation, 'pathname'))
  ) {
    return false;
  }

  return true;
}

exports.onClientEntry = () => {
  require('lazysizes');
  require('css-vars-ponyfill').default();
};
